import declare from "dojo/_base/declare";
import GroupController from "csi/action/GroupController";
import xml from "csi/xml";

const AffectedItemsGroupController = declare(GroupController, {
	/**
     * Add ParentAttr to request
     */
	toWriterRequest() {
		const req = this.inherited(arguments) as any;
		req.addParameter("ParentAttr", xml.ATTR_STRING, "AffectedItems");
		return req;
	},
});

export = AffectedItemsGroupController;